export const API_URL = 'https://forkify-api.jonas.io/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '4fd8e57b-fa2b-4fed-9a81-fc960b5ecb1e';
export const MODAL_CLOSE_SEC = 2.5;
